const HotkeyScopes = {
  // Default
  All: "all",

  ProcessDesigner: "process-designer",
  Search: "search",
  EditToolBox: "edit-tool-box",
  Alignments: "alignments",
  Colors: "colors",
  Icons: "icons",
  CustomStyles: "custom-styles",
  SelectFont: "select-font",
  // Sidebar
  Sidebar: {
    Teams: "teams",
    Players: "players",
    Processes: "processes",
    Options: "options",
  },
  SidebarContextMenu: "sidebar-context-menu",
  DeleteConfirmDialog: "delete-confirm-dialog",
  AddMemberDialog: "add-member-dialog",
  ProcessFlow: "process-flow",
  CellContextMenu: "cell-context-menu",
  goto: {
    shortcuts: "shortcuts",
    favorites: "favorites",
    search: "search",
  },
  MoreCommands: "more-commands",
  DropDown: "drop-down",
  FormulaSearch: "formula-search",
  QuickAccessToolbar: "quick-access-toolbar",
  Trash: "trash",
  GotoBox: "go-to-box",
  SeriesBox: "series-box",
  SmartSearch: "smart-search",
};

const PayPal = {
  mode: process.env.VUE_APP_PAYPAL_MODE || "live", // "live" or "sandbox"
  planID: process.env.VUE_APP_PAYPAL_PLAN_ID || "P-93P09919XH729912WM4SI7AY",
  testPlanId: process.env.VUE_APP_PAYPAL_SANDBOX_PLAN_ID || "P-5C71509159108260BM4W3XJY",
  subClientId:
    process.env.VUE_APP_PAYPAL_CLIENT_ID ||
    "AeJ5P7QfJqbeljfe_9w_bPtr62CR4t9yHnlB5SrbM4PdwkJ2GtBtvZgEfsyXluqSdCppf4cUvbMcPBwT",
  testSubClientId:
    process.env.VUE_APP_PAYPAL_SANDBOX_CLIENT_ID ||
    "AbICX6Wj5pGOZNjgnIdl2h2rZrTVSbJUaZs8wE2W965fWEoPi9pe4Z7n32Cy0M4MZqyA4uzPHmP5Apah",
  clientID:
    process.env.VUE_APP_PAYPAL_CLIENT_ID ||
    "AeJ5P7QfJqbeljfe_9w_bPtr62CR4t9yHnlB5SrbM4PdwkJ2GtBtvZgEfsyXluqSdCppf4cUvbMcPBwT",
  SecrectKey:
    process.env.VUE_APP_PAYPAL_SECRET ||
    "EJXGagWr-ihvlZJJacX6pweQkrMx6Bn3Jj0NusjFnAcVmprdamxgJDgSdFm_Glt0k-CoRXZDvT1s-6sH",
  testClientID:
    process.env.VUE_APP_PAYPAL_SANDBOX_CLIENT_ID ||
    "AbICX6Wj5pGOZNjgnIdl2h2rZrTVSbJUaZs8wE2W965fWEoPi9pe4Z7n32Cy0M4MZqyA4uzPHmP5Apah",
  testSecretKey:
    process.env.VUE_APP_PAYPAL_SANDBOX_SECRET ||
    "EADGhcAS8dhZ6rcXyl_YlMTJ94PN_J4F1hWp6lD6hbcCUXUaOAueUlUcpJ099X9mwyDg85s3N74Qwd9V",
  payPalTokenUrl: "https://api-m.paypal.com/v1/oauth2/token",
  PayPaSubUrl: "https://api-m.paypal.com/v1/billing/subscriptions",
  testTokenUrl: "https://api-m.sandbox.paypal.com/v1/oauth2/token",
  testSubUrl: "https://api-m.sandbox.paypal.com/v1/billing/subscriptions",

  // Derived helpers for easy switching
  get sdkClientId() {
    return this.mode === "sandbox" ? this.testSubClientId : this.subClientId;
  },
  get tokenUrl() {
    return this.mode === "sandbox" ? this.testTokenUrl : this.payPalTokenUrl;
  },
  get subUrl() {
    return this.mode === "sandbox" ? this.testSubUrl : this.PayPaSubUrl;
  },
  get planId() {
    return this.mode === "sandbox" ? this.testPlanId : this.planID;
  },
};

export { HotkeyScopes, PayPal };
